export const GameListData=[
    
    {
        url:"https://www.twitch.tv/directory/game/League%20of%20Legends" ,
        imageUrl:"https://static-cdn.jtvnw.net/ttv-boxart/21779-188x250.jpg" ,
        alt:"Imagem do jogo League of Legends",
    },
    {
        url:"https://www.twitch.tv/directory/game/VALORANT",
        imageUrl:"https://static-cdn.jtvnw.net/ttv-boxart/516575-188x250.jpg" ,
        alt:"Imagem do jogo Valorant",
    },
    {
        url:"https://www.twitch.tv/directory/game/Minecraft" ,
        imageUrl:"https://static-cdn.jtvnw.net/ttv-boxart/27471_IGDB-188x250.jpg" ,
        alt:"Imagem do jogo Minecraft",
    },
    {
        url:"https://www.twitch.tv/directory/game/Garena%20Free%20Fire" ,
        imageUrl:"https://static-cdn.jtvnw.net/ttv-boxart/502732_IGDB-144x192.jpg" ,
        alt:"Imagem clash royale",
    },
    {   
        url:"https://www.twitch.tv/directory/game/7%20Days%20to%20Die" ,
        imageUrl:"https://static-cdn.jtvnw.net/ttv-boxart/271304_IGDB-144x192.jpg" ,
        alt:"Imagem do 7 days to die",
    },
    {   
        url:"https://www.twitch.tv/directory/game/Clash%20Royale" ,
        imageUrl:"https://static-cdn.jtvnw.net/ttv-boxart/491168_IGDB-144x192.jpg" ,
        alt:"Imagem do jogo TFT",
    },
    
    
]

export const ListCanalData=[
    {
        Url:"https://www.twitch.tv/maykbrito",
        imgUrl:"https://static-cdn.jtvnw.net/jtv_user_pictures/9ce11a2b-ec84-44b1-9c76-b8d29df5fef0-profile_image-150x150.png" ,
        alt:"Imagem de Mayk Brito",
    },
    {
        Url:"https://www.twitch.tv/alanzoka",
        imgUrl:"https://static-cdn.jtvnw.net/jtv_user_pictures/64d44235-1dee-4bca-95da-bee1ee96eea3-profile_image-70x70.png" ,
        alt:"Imagem de Alanzoka",
    },
    {
        Url:"https://www.twitch.tv/playhard",
        imgUrl:"https://static-cdn.jtvnw.net/jtv_user_pictures/eac6f947-b09b-4bbc-bef9-79766a9b7b16-profile_image-70x70.png" ,
        alt:"Imagemd de PlayHard",
    },

                           
]

export const ListSocialData=[

    {
        url:"https://www.instagram.com/danniellrosa/",
        imageUrl:"./assets/instagram.svg",
        alt:"instagram Daniel Rosa",
    },
    
    {
        url:"https://www.youtube.com/channel/UCDQ7VolfTUHTM9BsHchwY0w",
        imageUrl:"./assets/youtube.svg",
        alt:"youtube Daniel Rosa",
    },
]
